import { connect } from "react-redux";
import {ResearchQuestions} from "../views/ResearchQuestions";

const mapStateToProps =(state) => {
    return {
        demographicInformation: state.demographicInformation
    }
}

export const ResearchQuestionsConnector = connect(mapStateToProps)(ResearchQuestions)